import { Action } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { takeLatest } from 'redux-saga/effects'
import { MovieModel } from '../models/MovieModel'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetMovies: '[Set Movies] Action',
  GetMovies: '[Get Movies] Action',
}

const initialMovieState: IMovieState = {
  movies: []
}

export interface IMovieState {
  movies?: MovieModel[]
  // movies: <MovieModel>
}

export const reducer = persistReducer(
  { storage, key: 'v100-demo1-movie', whitelist: ['movies'] },
  (state: IMovieState = initialMovieState, action: ActionWithPayload<IMovieState>) => {
    switch (action.type) {
      case actionTypes.SetMovies: {
        const movies = action.payload?.movies
        return { ...state, movies }
      }

      case actionTypes.GetMovies: {
        const movies = action.payload?.movies
        return { state, movies} // Puede que sobre escriba movie
      }

      default:
        return state
    }
  }
)

export const actions = {
  setMovies: (movie: MovieModel) => ({ type: actionTypes.SetMovies, payload: { movie } }),
  getMovies: () => ({ type: actionTypes.GetMovies, payload: { } })
}

export function* saga() {
  yield takeLatest(actionTypes.SetMovies, function* loginSaga() {
    // yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.GetMovies, function* registerSaga() {
    // yield put(actions.requestUser())
  })
}

